import { Component, Input, Output, EventEmitter, OnInit } from '@angular/core';
import { FormControl } from '@angular/forms';
import { Observable } from 'rxjs';
import { map, startWith } from 'rxjs/operators';
import { MultiSelectItem } from '../../interfaces/multi-select.interface';

@Component({
  selector: 'app-multi-select',
  templateUrl: './multi-select.component.html',
  styleUrls: ['./multi-select.component.css']
})
export class MultiSelectComponent implements OnInit {
  @Input() items: MultiSelectItem[] = [];
  @Input() selectedItems: MultiSelectItem[] = [];
  @Input() placeholder: string = 'Auswählen...';
  @Input() label: string = '';
  @Input() loading: boolean = false;
  @Input() disabled: boolean = false;

  @Output() selectionChange = new EventEmitter<MultiSelectItem[]>();

  searchControl = new FormControl('');
  filteredItems: Observable<MultiSelectItem[]>;

  ngOnInit(): void {
    this.filteredItems = this.searchControl.valueChanges.pipe(
      startWith(''),
      map(value => this._filter(value || ''))
    );
  }

  private _filter(value: string): MultiSelectItem[] {
    const filterValue = value.toLowerCase();
    return this.items.filter(item => 
      item.name.toLowerCase().includes(filterValue) ||
      (item.description && item.description.toLowerCase().includes(filterValue))
    );
  }

  isSelected(item: MultiSelectItem): boolean {
    return this.selectedItems.some(selected => selected.id === item.id);
  }

  toggleSelection(item: MultiSelectItem): void {
    if (this.isSelected(item)) {
      this.selectedItems = this.selectedItems.filter(selected => selected.id !== item.id);
    } else {
      this.selectedItems = [...this.selectedItems, item];
    }
    this.selectionChange.emit(this.selectedItems);
  }

  removeItem(item: MultiSelectItem): void {
    this.selectedItems = this.selectedItems.filter(selected => selected.id !== item.id);
    this.selectionChange.emit(this.selectedItems);
  }

  clearAll(): void {
    this.selectedItems = [];
    this.selectionChange.emit(this.selectedItems);
  }
}
